export default "__VITE_ASSET__CEA1O_Eh__"